<template>
  <div class="mx-2 mt-4">
    <div
      class="mb-5 pb-4 border shadow-lg border-primary-50 text-white dark:text-dark-text dark:bg-dark-800 dark:border-dark-400"
      style="border-radius: 1rem"
    >
      <div
        class="flex text-lg bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700"
        :class="isLightMode() ? 'top' : 'top-dark'"
        style="border-top-right-radius: 1rem; border-top-left-radius: 1rem"
      >
        <span class="material-icons mr-2">label</span>
        <div>{{ $t('message.problemCategory') }}</div>
      </div>
      <div v-if="series.length == 0" class="mt-3 ml-3">
        {{ $t('message.noData') }}
      </div>
      <VueApexCharts
        v-else
        class="mt-2"
        height="450"
        :options="nested.chartOptions.value"
        :series="series"
        type="pie"
      />
    </div>
    <div class="grid grid-cols-2">
      <div
        class="mb-5 pb-4 mr-2 border shadow-lg border-primary-50 text-white dark:text-dark-text dark:bg-dark-800 dark:border-dark-400"
        style="border-radius: 1rem"
      >
        <div
          class="flex text-lg bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700"
          :class="isLightMode() ? 'top' : 'top-dark'"
          style="border-top-right-radius: 1rem; border-top-left-radius: 1rem"
        >
          <span class="material-icons mr-2">label</span>
          <div>{{ $t('message.userSubmissions') }}</div>
        </div>
        <div v-if="seriesStatus.length == 0" class="mt-3 ml-3">
          {{ $t('message.noData') }}
        </div>
        <VueApexCharts
          v-else
          class="mt-2"
          height="450"
          :options="nested.chartOptionsStatus.value"
          :series="seriesStatus"
          type="pie"
        />
      </div>
      <div
        class="mb-5 pb-4 ml-2 border shadow-lg border-primary-50 text-white dark:text-dark-text dark:bg-dark-800 dark:border-dark-400"
        style="border-radius: 1rem"
      >
        <div
          class="flex text-lg bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700"
          :class="isLightMode() ? 'top' : 'top-dark'"
          style="border-top-right-radius: 1rem; border-top-left-radius: 1rem"
        >
          <span class="material-icons mr-2">label</span>
          <div>{{ $t('message.languageSubmissions') }}</div>
        </div>
        <div v-if="seriesLanguage.length == 0" class="mt-3 ml-3">
          {{ $t('message.noData') }}
        </div>
        <VueApexCharts
          v-else
          class="mt-2"
          height="450"
          :options="nested.chartOptionsLanguage.value"
          :series="seriesLanguage"
          type="pie"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { ProblemCategory } from '@/domain/entities/problem/problemCategory'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useProblemStatisticsPresenter } from '@/presentation/composables/problem/useProblemStatisticsPresenter'

export default defineComponent({
  components: { VueApexCharts },
  setup(props) {
    const { isLightMode } = useConfigStatePresenter()
    const problemStatisticsPresenter = useProblemStatisticsPresenter()

    const problemCategories: ProblemCategory[] = problemStatisticsPresenter.problemAttachment.value.problemCategories

    const series: number[] = []
    const labels: string[] = []

    for (let i = 0; i < problemCategories.length; i++) {
      series.push(problemCategories[i].users.length)
    }

    for (let i = 0; i < problemCategories.length; i++) {
      for (let j = 0; j < problemStatisticsPresenter.officialProblemCategoryList.value.length; j++) {
        if (
          problemCategories[i].categoryId == problemStatisticsPresenter.officialProblemCategoryList.value[j].categoryId
        ) {
          labels.push(problemStatisticsPresenter.officialProblemCategoryList.value[j].middleCl)
          break
        }
      }
    }

    const seriesStatus: number[] = []
    const labelsStatus: string[] = []

    for (let i = 0; i < problemStatisticsPresenter.problemStatistics.value.statusStatistics.status.length; i++) {
      seriesStatus.push(problemStatisticsPresenter.problemStatistics.value.statusStatistics.value[i])
      labelsStatus.push(problemStatisticsPresenter.problemStatistics.value.statusStatistics.status[i])
    }

    const seriesLanguage: number[] = []
    const labelsLanguage: string[] = []

    for (let i = 0; i < problemStatisticsPresenter.problemStatistics.value.languageStatistics.language.length; i++) {
      seriesLanguage.push(problemStatisticsPresenter.problemStatistics.value.languageStatistics.value[i])
      labelsLanguage.push(problemStatisticsPresenter.problemStatistics.value.languageStatistics.language[i])
    }

    const chartOptions = ref({
      plotOptions: {
        chart: {
          type: 'pie'
        }
      },
      legend: {
        position: 'bottom',
        fontSize: '16px',
        labels: {
          colors: isLightMode() ? '' : '#dfdfdf'
        }
      },
      stroke: {
        colors: isLightMode() ? ['#fff'] : ['#2E2E2E']
      },
      colors: [
        '#008FFB',
        '#00E396',
        '#FEB019',
        '#FF4560',
        '#775DD0',
        '#b33e5c',
        '#594e52',
        '#387d39',
        '#c1ab05',
        '#4753a2'
      ],
      labels: labels,
      responsive: [
        //画面サイズに合わせて再レイアウト
        {
          breakpoint: 0,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      ]
    })

    const chartOptionsStatus = ref({
      plotOptions: {
        chart: {
          type: 'pie'
        }
      },
      legend: {
        position: 'bottom',
        fontSize: '16px',
        labels: {
          colors: isLightMode() ? '' : '#dfdfdf'
        }
      },
      stroke: {
        colors: isLightMode() ? ['#fff'] : ['#2E2E2E']
      },
      colors: [
        '#00E396',
        '#FF4560',
        '#FEB019',
        '#c70067',
        '#775DD0',
        '#d15869',
        '#594e52',
        '#387d39',
        '#c1ab05',
        '#4753a2'
      ],
      labels: labelsStatus,
      responsive: [
        //画面サイズに合わせて再レイアウト
        {
          breakpoint: 0,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      ]
    })

    const chartOptionsLanguage = ref({
      plotOptions: {
        chart: {
          type: 'pie'
        }
      },
      legend: {
        position: 'bottom',
        fontSize: '16px',
        labels: {
          colors: isLightMode() ? '' : '#dfdfdf'
        }
      },
      stroke: {
        colors: isLightMode() ? ['#fff'] : ['#2E2E2E']
      },
      colors: [
        '#008FFB',
        '#00E396',
        '#FEB019',
        '#FF4560',
        '#775DD0',
        '#b33e5c',
        '#594e52',
        '#387d39',
        '#c1ab05',
        '#4753a2',
        '#8b008b',
        '#808000',
        '#00ced1',
        '#ff6347',
        '#b0c4de',
        '#2f4f4f',
        '#f0e68c',
        '#66cdaa'
      ],
      labels: labelsLanguage,
      responsive: [
        //画面サイズに合わせて再レイアウト
        {
          breakpoint: 0,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      ]
    })

    watch(
      () => isLightMode(),
      () => {
        chartOptions.value = {
          plotOptions: {
            chart: {
              type: 'pie'
            }
          },
          legend: {
            position: 'bottom',
            fontSize: '16px',
            labels: {
              colors: isLightMode() ? '' : '#dfdfdf'
            }
          },
          stroke: {
            colors: isLightMode() ? ['#fff'] : ['#2E2E2E']
          },
          colors: [
            '#008FFB',
            '#00E396',
            '#FEB019',
            '#FF4560',
            '#775DD0',
            '#b33e5c',
            '#594e52',
            '#387d39',
            '#c1ab05',
            '#4753a2'
          ],
          labels: labels,
          responsive: [
            //画面サイズに合わせて再レイアウト
            {
              breakpoint: 0,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
        chartOptionsStatus.value = {
          plotOptions: {
            chart: {
              type: 'pie'
            }
          },
          legend: {
            position: 'bottom',
            fontSize: '16px',
            labels: {
              colors: isLightMode() ? '' : '#dfdfdf'
            }
          },
          stroke: {
            colors: isLightMode() ? ['#fff'] : ['#2E2E2E']
          },
          colors: [
            '#00E396',
            '#FF4560',
            '#FEB019',
            '#c70067',
            '#775DD0',
            '#d15869',
            '#594e52',
            '#387d39',
            '#c1ab05',
            '#4753a2'
          ],
          labels: labelsStatus,
          responsive: [
            //画面サイズに合わせて再レイアウト
            {
              breakpoint: 0,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
        chartOptionsLanguage.value = {
          plotOptions: {
            chart: {
              type: 'pie'
            }
          },
          legend: {
            position: 'bottom',
            fontSize: '16px',
            labels: {
              colors: isLightMode() ? '' : '#dfdfdf'
            }
          },
          stroke: {
            colors: isLightMode() ? ['#fff'] : ['#2E2E2E']
          },
          colors: [
            '#008FFB',
            '#00E396',
            '#FEB019',
            '#FF4560',
            '#775DD0',
            '#b33e5c',
            '#594e52',
            '#387d39',
            '#c1ab05',
            '#4753a2',
            '#8b008b',
            '#808000',
            '#00ced1',
            '#ff6347',
            '#b0c4de',
            '#2f4f4f',
            '#f0e68c',
            '#66cdaa'
          ],
          labels: labelsLanguage,
          responsive: [
            //画面サイズに合わせて再レイアウト
            {
              breakpoint: 0,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      }
    )

    return {
      series,
      seriesStatus,
      seriesLanguage,
      nested: { chartOptions, chartOptionsStatus, chartOptionsLanguage },
      isLightMode
    }
  }
})
</script>
<style lang="postcss" scoped>
.top {
  padding: 0.7em 1em 0.7em 1em;
}
.top-dark {
  padding: 0.7em 1em 0.7em 1em;
}
</style>
